module.exports = __webpack_public_path__ + "media/files/sample_agency_check_file-9a564e8705d4f978d47a3c1f61e4a92a.xlsx";